"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Desio certificazione contatti
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClienteDtoToJSON = exports.ClienteDtoFromJSONTyped = exports.ClienteDtoFromJSON = void 0;
const runtime_1 = require("../runtime");
function ClienteDtoFromJSON(json) {
    return ClienteDtoFromJSONTyped(json, false);
}
exports.ClienteDtoFromJSON = ClienteDtoFromJSON;
function ClienteDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'ndg': !runtime_1.exists(json, 'ndg') ? undefined : json['ndg'],
        'nominativo': !runtime_1.exists(json, 'nominativo') ? undefined : json['nominativo'],
        'dataInserimento': !runtime_1.exists(json, 'dataInserimento') ? undefined : (new Date(json['dataInserimento'])),
    };
}
exports.ClienteDtoFromJSONTyped = ClienteDtoFromJSONTyped;
function ClienteDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'ndg': value.ndg,
        'nominativo': value.nominativo,
        'dataInserimento': value.dataInserimento === undefined ? undefined : (value.dataInserimento.toISOString()),
    };
}
exports.ClienteDtoToJSON = ClienteDtoToJSON;
